import { useCallback, useState } from 'react';

export const useToast = () => {
  const [toast, setToast] = useState(null);

  const showToast = useCallback((message) => {
    setToast(message);
    setTimeout(() => setToast(null), 5000);
  }, []);

  return { toast, showToast };
};
